import React from 'react';
import { selectVulnSelectedTab } from 'store/Contextualization/AssetDetail/selectors';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import TABS from './tabs';
import { TabSelectorWrapper, TabButton } from 'Screens/Contextualization/Manage/components/VulnerabilityDetail/components/Tabs/components/TabSelector/styled';
import { setVulnerabilityDetailTab } from 'store/Contextualization/AssetDetail/actions';
import useTabsShortcuts from 'Hooks/useTabsShortcuts';

const Tabs = ({ scope }) => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const selectedTab = useSelector(selectVulnSelectedTab);

  const getLabel = (tab) => intl.formatMessage({ id: tab.intlId });
  const isActive = (tab) => tab.id === selectedTab.id;

  useTabsShortcuts({
    tabs: TABS,
    activeId: selectedTab.id,
    onChange: (id) => dispatch(setVulnerabilityDetailTab(id)),
    scope
  });

  return (
    <TabSelectorWrapper>
      { TABS.map((tab) => (
        <TabButton
          active={ isActive(tab) }
          key={ tab.id }
          onClick={ () => dispatch(setVulnerabilityDetailTab(tab.id)) }
          children={ getLabel(tab) }
        />
      ))}
    </TabSelectorWrapper>
  );
};

export default Tabs;
